<template>
  <div class="recommend-rank">
    <div class="rank-banner"><img :src="bannerImg" alt=""></div>
    <div class="recommend-rank-box">
      <!-- 期数 -->
      <div class="rank-No">
        <div class="rank-No-number">{{myRecommendgInfo.Cycle || '----'}}期</div>
        <div class="rank-number">
          <div class="rank-number-item">
            <div class="count">{{myRecommendgInfo.RecommendCount || 0}}<span class="rank-small-txt"> 人</span></div>
            <div>成功推荐人数</div>
          </div>
          <div class="rank-number-item">
            <div class="count">
              <template v-if="myRecommendgInfo.CycleRankingOutPartner">
                {{myRecommendgInfo.CycleRankingOutPartner}}<span class="rank-small-txt"> 名</span>
              </template>
              <template v-else><span class="rank-small-txt">无名次</span></template>
            </div>
            <div>当前排名</div>
          </div>
        </div>
        <div class="rank-No-btn" @click="shareClick">推荐好友，赢免单卡</div>
      </div>
      <!-- 列表 -->
      <div class="rank-list box">
        <div class="rank-tab">
          <p :class="{'active': currentTab === 0}" @click="tabChange(0)">已推荐好友</p>
          <p :class="{'active': currentTab === 1}" @click="tabChange(1)">推荐排行榜</p>
        </div>
        <template v-if="isPartner">
          <div class="rank-list-no">
            <span class="t_999">合伙人不参与奖励免单卡活动</span>
          </div>
        </template>
        <template v-else>
          <div class="rank-alert">
            <template v-if="currentTab === 0">
              <span>本期已成功推荐 {{rcomFriendTotal}} 位好友</span>
            </template>
            <template v-else>
              <span>本期推荐排行榜</span>
              <span class="t_blue" @click="goHistotyRank">查看往期排行<i class="iconfont icon-xiangzuo1"></i></span>
            </template>
          </div>
          <!-- list -->
          <div
            class="rank-list-box"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="scrollDisabled"
            infinite-scroll-immediate-check="false">
              <template v-if="currentTab === 0">
                <div class="rank-list-item" v-for="(item, index) in dataList" :key="index">
                  <div class="user-info">
                    <p class="no">{{index + 1}}</p>
                    <div class="img"><img :src="item.HeadPortraitUrl" alt=""></div>
                    <div class="info">
                      <p class="nick">{{item.Nick | filterNickName}}</p>
                    </div>
                  </div>
                  <p class="t_999">{{item.CreateTime | formatTime}}</p>
                </div>
                <div class="rank-list-no" v-if="dataList.length <= 0">
                  <span class="t_999">暂无推荐好友，块去邀请吧~</span>
                </div>
              </template>
              <template v-else>
                <div class="rank-list-item" v-for="(item, index) in dataList" :key="index">
                  <div class="user-info">
                    <p class="no">{{index === 0 ? '' : index}}</p>
                    <div class="img"><img :src="item.HeadPortraitUrl" alt=""></div>
                    <div class="info">
                      <p class="nick">{{item.Nick | filterNickName}}</p>
                      <p class="t_999" v-if="index === 0 && myRecommendgInfo.RecommendCount <= 0">无名次</p>
                      <p class="t_999" v-else>第 {{item.RecommendRank || '--'}} 名</p>
                    </div>
                  </div>
                  <p class="t_f23030">{{item.RecommendCount}} 人</p>
                </div>
                <div class="rank-list-no" v-if="rankListToatal <= 0">
                  <span class="t_999">暂无用户参与活动</span>
                </div>
              </template>
              <div
                v-if="haveMore && !loading"
                :class="{'rank-scoll-loading load-anim': true, 'load-anim': loading}">
                  <span class="iconfont icon-shuaxin t_999"></span>
              </div>
          </div>
          <div class="rank-scoll-tip">
            <span class="t_999" v-if="dataList.length >= 0 && haveMore">滑动查看更多</span>
          </div>
          <!-- list end -->
        </template>
      </div>
      <!-- 规则 -->
      <div class="box">
        <div>活动规则</div>
        <div class="rules-box">
          <div class="rules-item">
            <div class="rules-icon"><i class="iconfont icon-fenxiang1"></i></div>
            <div>
              <p>1.邀请好友</p>
              <p class="t_999">点击按钮，分享邀请图片给好友</p>
            </div>
          </div>
          <div class="cloum-line"></div>
          <div class="rules-item">
            <div class="rules-icon"><i class="iconfont icon-ic_people_black_px"></i></div>
            <div>
              <p>2.好友注册</p>
              <p class="t_999">被邀请人成功注册搜货精选</p>
            </div>
          </div>
          <div class="cloum-line"></div>
          <div class="rules-item">
            <div class="rules-icon"><i class="iconfont icon-trophyfill"></i></div>
            <div>
              <p>3.每周一颁奖</p>
              <p class="t_999">系统将于每周一上午10点发放免单卡，第一名奖励{{freeCartConfig.FirstFreeCard}}张，第二名奖励{{freeCartConfig.SecondFreeCard}}张，第三名奖励{{freeCartConfig.ThirdFreeCard}}张</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
import moment from 'moment'
import {
  MyRecommendgGet,
  RecommendFriendList,
  RecommendRankList,
  AwardFreeCardConfig
} from '@/api/recommendRank'
import { Indicator, Toast } from 'mint-ui'

export default {
  name: 'RecommendRank',
  data () {
    return {
      loading: false,
      haveMore: false,
      bannerImg: IMG_BASE_URL + '/upaiyun/Sys/20190710/5025037290257628245.jpg',
      scrollDisabled: false,
      currentTab: 0,
      myRecommendgInfo: {},
      // 是否为合伙人
      isPartner: false,
      // 推荐总数
      rcomFriendTotal: 0,
      // 历史推荐人总数
      rankListToatal: 0,
      freeCartConfig: {
        FirstFreeCard: 0,
        SecondFreeCard: 0,
        ThirdFreeCard: 0
      },
      dataList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1,
      pageRows: 3
    }
  },
  mounted () {
    this.fetchData()
    document.documentElement.scrollTop = 0
  },
  methods: {
    fetchData () {
      this.fetchMyRecommend()
      this.fetchFriendList()
      this.fetchFreeCartConfig()
    },
    // 获取我的推荐数据
    fetchMyRecommend () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      MyRecommendgGet().then(res => {
        this.myRecommendgInfo = res.Data
        this.isPartner = this.myRecommendgInfo.IsPartner
        Indicator.close()
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 获取推荐好友列表
    fetchFriendList () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        Page: this.currentPage,
        Rows: this.pageRows
      }
      this.scrollDisabled = true
      this.loading = true
      RecommendFriendList(params).then(res => {
        this.dataList = [...this.dataList, ...res.DataList]
        Indicator.close()
        this.scrollDisabled = false
        this.loading = false
        this.page = res.PaginationViewModel.Page
        this.pageCount = res.PaginationViewModel.PageCount
        this.rcomFriendTotal = res.PaginationViewModel.Total
        if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
          this.haveMore = false
        } else {
          this.haveMore = true
        }
      }).catch(err => {
        this.haveMore = false
        this.loading = false
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 获取推荐排行榜列表
    fetchRankList () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        Page: this.currentPage,
        Rows: this.pageRows
      }
      this.scrollDisabled = true
      this.loading = true
      RecommendRankList(params).then(res => {
        let myInfo = res.MyRank
        if (myInfo) this.dataList = [res.MyRank, ...this.dataList, ...res.DataList]
        else this.dataList = [...this.dataList, ...res.DataList]
        Indicator.close()
        this.scrollDisabled = false
        this.loading = false
        this.page = res.PaginationViewModel.Page
        this.pageCount = res.PaginationViewModel.PageCount
        this.rankListToatal = res.PaginationViewModel.Total
        if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
          this.haveMore = false
        } else {
          this.haveMore = true
        }
      }).catch(err => {
        this.haveMore = false
        this.loading = false
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 获取免单卡配置
    fetchFreeCartConfig () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      AwardFreeCardConfig().then(res => {
        this.freeCartConfig = res.Data
        Indicator.close()
      }).catch(res => {
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    tabChange (val) {
      this.currentTab = val
      this.currentPage = 1
      this.pageRows = 3
      this.dataList = []
      if (this.currentTab) {
        // 排行榜
        this.fetchRankList()
      } else {
        this.fetchFriendList()
      }
    },
    // 查看往期排行
    goHistotyRank () {
      this.$router.push('recommendHistory')
    },
    // 邀请好友
    shareClick () {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          pageType: 13
        }
      })
    },
    // 加载更多
    loadMore () {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.pageRows = 10
      this.haveMore = true
      if (this.currentTab) {
        // 排行榜
        this.fetchRankList()
      } else {
        this.fetchFriendList()
        this.loading = true
      }
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        return moment(val).format('YYYY-M-D')
      } else {
        return '----'
      }
    },
    filterNickName (val) {
      if (!val) return '----'
      if (val.length > 4) return val.substring(0, 4) + '...'
      else return val
    }
  }
}
</script>

<style scoped>
  .recommend-rank{
    min-height: 100vh;
    width: 100%;
    background: #cdefd8;
    font-size: 14px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .rank-banner{
    height: 8.05rem;
  }
  .rank-banner img{
    height: 100%;
    width: 100%;
    display: block;
  }
  /* 主体 */
  .recommend-rank-box{
    position: relative;
    box-sizing: border-box;
    padding: 10px 2% 2% 2%;
  }
  .recommend-rank-box .box{
    background: #fff;
    border-radius: 10px;
    padding: 3% 4%;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 10px;
  }
  .rank-No{
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 30px 0 4% 0;
    box-sizing: border-box;
    font-size: 14px;
  }
  .rank-No-number{
    position: absolute;
    top: -4px;
    left: 18px;
    background: #60c781;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 6px 5px;
    font-size: 13px;
    color: #fff;
    z-index: 5;
  }
  .rank-No-number::before,
  .rank-No-number::after{
    content: '';
    top: -7px;
    left: 10px;
    position: absolute;
    width: 4px;
    height: 12px;
    background: #bcbcbc;
  }
  .rank-No-number::after{
    left: initial;
    right: 10px;
  }
  .rank-number{
    display: flex;
    align-items: center;
    justify-content: space-between
  }
  .rank-number-item{
    flex-grow: 1;
    text-align: center;
  }
  .rank-number-item .count{
    color: #ff0000;
    font-size: 18px;
    font-weight: 500;
  }
  .rank-number-item > div:last-child{margin-top: 5px;}
  .rank-small-txt{
    font-weight: 400;
    font-size: 13px;
  }
  .rank-No-btn{
    width: 65%;
    background: #60c781;
    color: #fff;
    text-align: center;
    margin: 20px auto 0 auto;
    height: 40px;
    line-height: 40px;
    border-radius: 30px;
    cursor: pointer;
  }
  /* 列表 */
  .rank-tab{
    width: 85%;
    margin: 0 auto;
    border: 1px solid #60c781;
    height: 35px;
    line-height: 35px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .rank-tab p{
    flex-grow: 1;
    text-align: center;
    color: #999;
    cursor: pointer;
    transition: all 0.3s ease-in;
  }
  .rank-tab .active{
    background: #60c781;
    color: #fff;
  }
  .rank-alert{
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    border-radius: 5px;
    color: #898989;
    background: #f2f2f2;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .rank-alert .t_blue > i{
    font-size: 13px;
    margin-left: 2px;
    cursor: pointer;
  }
  .rank-list-box{
    max-height: 214px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .rank-list-item{
    width: 100%;
    height: 70px;
    background: #fff;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    padding-right: 15px;
  }
  .rank-list-item .user-info{
    height: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
  }
  .user-info .no{
    min-width: 15px;
    min-height: 15px;
    line-height: 1;
    text-align: center;
  }
  .user-info .img{
    width: 48px;
    height: 48px;
  }
  .user-info .img img{
    height: 100%;
    width: 100%;
    display: block;
    border-radius: 50%;
  }
  .user-info .info{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }
  .user-info .info .t_999{
    font-size: 13px;
  }
  .rank-list-no{
    height: 70px;
    line-height: 70px;
    text-align: center;
  }
  .rank-scoll-tip,
  .rank-scoll-loading{
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .load-anim .iconfont{
    font-size: 18px;
    display: inline-block;
    animation-fill-mode: backwards;
    animation: loadingAnim .5s linear infinite;
  }
  /* 规则 */
  .rules-box{
    margin-top: 15px;
  }
  .rules-box .rules-item{
    display: flex;
  }
  .rules-item:first-child{
    margin-top: 0;
  }
  .rules-item .rules-icon{
    flex-shrink: 0;
    background: #60c781;
    color: #fff;
    height: 44px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 10px;
  }
  .rules-item .t_999{
    padding-left: 8px;
  }
  .rules-icon .iconfont{
    font-size: 22px;
  }
  /* line */
  .rules-box .cloum-line{
    height: 24px;
    border-left: 2px dotted #bcbcbc;
    margin: 5px 0 5px 22px;
  }
  @media screen and (max-width: 320px){
    .rank-banner{
      height: 6.95rem;
    }
  }
  @media screen and (min-width: 414px){
    .rank-banner{
      height: 8.95rem;
    }
  }
  @keyframes loadingAnim{
    0%{
      transform: rotateZ(0deg);
    }
    100%{
      transform: rotateZ(360deg);
    }
  }
</style>
